module.exports = __webpack_public_path__ + "static/media/stripe.f3a0691d.svg";